import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Flex,
  IconButton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Heading,
  Tr,
  useColorModeValue,
  useToast,
  Text,
  Center,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import Default from 'components/fields/InputField';
import { useRef, useState, useCallback, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { HSeparator } from 'components/separator/Separator';
import InterfaceSelect from 'components/select';
// import { useParams } from 'react-router-dom';
// import AssetParamDialog from './modal/assetParam';
import axiosInstance from 'api/axiosInstance';
import apiUrls from 'api/apiUrls';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import GlobalAlertDialog from 'components/GlobalAlertDialog';
import {
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
} from '@chakra-ui/icons';
import TableSkeleton from '../configure/components/tableSkeleton';
import AssetParamDialog from '../configure/modal/assetParam';
import Sidebar from 'components/sidebar/Sidebar';
import ThresholdModal from '../thresholds/modal/ThresholdModal';
import { sortDevices } from 'views/hooks/sortDevices';
import Cookies from 'js-cookie';
import ClusterModal from 'components/ClusterModal';
import BreadCrumb from 'components/breadCrumb/BreadCrumb';

const PLATFORM_ID = process.env.REACT_APP_PLATFORM_ID;

// Device type mappings (display names for select, numbers for payload)
const deviceTypeDisplayMap = { 1: 'MINI', 2: 'GRIDX', 3: 'MINI SECURE' };
const deviceTypeReverseMap = { MINI: 1, GRIDX: 2, 'MINI SECURE': 3 };

export default function SlaveConfigurations() {
  const userAuthority = localStorage.getItem('userAuthority');
  const customerId = localStorage.getItem('customerId');
  const isTenantAdmin = userAuthority === 'TENANT_ADMIN';

  const toast = useToast();
  const cardBg = useColorModeValue('white', 'navy.700');
  const textColor = useColorModeValue('navy.700', 'white');
  const inputBg = useColorModeValue('white', 'navy.600');
  const [configName, setConfigName] = useState('');
  const [configId, setConfigId] = useState(null);
  const deviceId = localStorage.getItem('deviceId');
  const modbusId = localStorage.getItem('configId');
  const isFirstRender = useRef(true);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectAllFlag, setSelectAllFlag] = useState(false);
  const selectAllFlagRef = useRef(false);
  const [serialNumber, setSerialNumber] = useState('');
  const [gridxType, setGridxType] = useState('');

  const groupID = localStorage.getItem('groupID');

  const [configurations, setConfigurations] = useState([]);
  const [originalData, setOriginalData] = useState({});
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [openAssetMastermodel, setAssetMasterOpen] = useState(false);
  const [currentSlaveId, setCurrentSlaveId] = useState(null);
  const [deviceTypeKey, setDeviceTypeKey] = useState(1);
  const [maxSlavePerDevice, setMaxSlavePerDevice] = useState(10);
  const [maxSlavePerInterFace, setMaxSlavePerInterFace] = useState(1);
  const [maxSlaveParameters, setMaxSlaveParameters] = useState(30);
  const [loadingDevices, setLoadingDevices] = useState(false);
  const [devicesArray, setDevicesArray] = useState([]);
  const [currentPage, setCurrentPage] = useState(-1);
  const [hasNext, setHasNext] = useState(false);
  const [interfaceList, setInterfaceList] = useState([]);
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });
  const [interfaceSettingsMap, setInterfaceSettingsMap] = useState({});
  const sidebarExpandedWidth = '260px';
  const sidebarCollapsedWidth = '80px';
  const sidebarWidth = collapsed ? sidebarCollapsedWidth : sidebarExpandedWidth;
  const { id: urlConfigId } = useParams();
  const [thresholdModalOpen, setThresholdModalOpen] = useState(false);
  const [selectedThresholdParam, setSelectedThresholdParam] = useState(null);
  const [maxThreshold, setMaxThreshold] = useState('');
  const [minThreshold, setMinThreshold] = useState('');
  const location = useLocation();
  const devices = location.state?.devices || [];
  const [isApplyConfirmOpen, setIsApplyConfirmOpen] = useState(false);
  const [invalidSlaveIds, setInvalidSlaveIds] = useState({});
  const [searchType, setSearchType] = useState('deviceId');
  const [clusterOptions, setClusterOptions] = useState([]);
  const [selectedCluster, setSelectedCluster] = useState('');
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [nocOptions, setNocOptions] = useState([]);
  const [selectedNoc, setSelectedNoc] = useState('');
  const [plantOptions, setPlantOptions] = useState([]);
  const [selectedPlant, setSelectedPlant] = useState('');
  const [configDeviceMap, setConfigDeviceMap] = useState({});
  const [preselectedDevices, setPreselectedDevices] = useState([]);
  const [preselectedDeviceIds, setPreselectedDeviceIds] = useState([]);
  const navigate = useNavigate();

  const status = location.state?.status;
  const isActive = location.state?.isActive;

  const {
    isOpen: isOpenSaveConf,
    onOpen: DeviceSaveConf,
    onClose: onCloseSaveConf,
  } = useDisclosure();

  const {
    isOpen: isOpenSaveConfApply,
    onOpen: DeviceSaveConfApply,
    onClose: onCloseSaveConfApply,
  } = useDisclosure();

  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', JSON.stringify(collapsed));
  }, [collapsed]);

  const closeAssetParameterModal = () => {
    setAssetMasterOpen(false);
  };

  useEffect(() => {
    selectAllFlagRef.current = selectAllFlag;
  }, [selectAllFlag]);

  const fetchAllDevices = useCallback(
    async (serialNumber = '', setLoading = true, page = 0) => {
      setLoadingDevices(setLoading);

      let apiUrl = apiUrls.allDevices(serialNumber, page);

      const resp = await axiosInstance.get(apiUrl);

      const devices = resp.data.data;
      setHasNext(resp.data.hasNext);

      const devicesNameIdMap = sortDevices(devices.map((d) => d.name)).map(
        (name) => ({
          id: name,
          name,
        }),
      );

      if (serialNumber || page === 0) {
        setDevicesArray(devicesNameIdMap);
      } else {
        setDevicesArray((prev) => {
          const existingIds = new Set(prev.map((d) => d.id));
          const newDevices = devicesNameIdMap.filter(
            (d) => !existingIds.has(d.id),
          );
          return [...prev, ...newDevices];
        });

        if (selectAllFlagRef.current) {
          setSelectedDevices((prev) => {
            const existingIds = new Set(prev);
            const newIds = devicesNameIdMap
              .map((d) => d.id)
              .filter((id) => !existingIds.has(id));
            return [...prev, ...newIds];
          });
        }
      }

      setLoadingDevices(false);
    },
    [deviceId],
  );

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (serialNumber) {
      setCurrentPage(0);
    }

    if (currentPage === -1) return;

    if (searchType === 'deviceId') {
      fetchAllDevices(serialNumber, true, currentPage);
    }
  }, [currentPage, serialNumber, fetchAllDevices, searchType]);

  const isSlaveChanged = (slave) => {
    const original = originalData[slave.id];
    return JSON.stringify(slave) !== JSON.stringify(original);
  };

  const writeFunctionCodes = {
    'Read Only': -1,
    'Write Coil': 5,
    'Write Register': 6,
    'Multiple Write': 10,
  };

  const ParamTypes = {
    '16bit_int': 1,
    '32bit_uint': 2,
    '32bit_float': 3,
    '16bit_uint': 14,
    '32bit_int': 18,
    '16bit_float': 26,
    Str: 42,
    bool: 43,
  };

  const RegisterDataType = {
    DCBA: 1,
    BADC: 3,
    Bool: 2,
  };

  const Actions = {
    'Read Only': 0,
    'Read Write': 1,
  };

  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [interfaceIdMap, setInterfaceIdMap] = useState({});
  const [modbusConfigMap, setmodbusConfigMap] = useState({});
  const [interfaceNumberMap, setInterfaceNumberMap] = useState({});
  const [selectedModbusConfigId, setSelectedModbusConfigId] = useState('');
  const breadcrumbItems = [
    { label: 'Home', path: '/dashboard' },
    { label: 'All Configurations', path: '/modbus-configs' },
    { label: modbusConfigMap[urlConfigId], path: null },
  ];

  const showError = (message) => {
    setErrorMessage(message);
    setIsErrorOpen(true);
  };

  const confirmDelete = (type, slaveId, paramId = null) => {
    setDeleteTarget({ type, slaveId, paramId });
    setIsDeleteOpen(true);
  };

  const defaultParameter = {
    id: uuidv4(),
    name: '',
    fn_code: 3,
    address: 0,
    type: 9,
    factor: 1,
    register_count: 1,
    register_data_type: 1,
    offset: 0,
    write_fn_code: -1,
    access: 0,
  };
  const handleDeleteConfirmed = () => {
    if (deleteTarget.type === 'slave') {
      setConfigurations((prev) =>
        prev.filter((slave) => slave.id !== deleteTarget.slaveId),
      );
    } else if (deleteTarget.type === 'parameter') {
      setConfigurations((prev) =>
        prev.map((slave) => {
          if (slave.id !== deleteTarget.slaveId) return slave;
          return {
            ...slave,
            parameters: slave.parameters.filter(
              (param) => param.id !== deleteTarget.paramId,
            ),
          };
        }),
      );
    }
    setIsDeleteOpen(false);
    setDeleteTarget({ type: null, slaveId: null, paramId: null });
  };

  const fetchModbusData = useCallback(
    async (configId) => {
      try {
        const keys = 'modbus_config,interfaces,config_device_type';
        const resp = await axiosInstance.get(
          apiUrls.toolDeviceAttributesV1(PLATFORM_ID, groupID, configId, keys),
        );
        let attrMap;
        if (Array.isArray(resp.data)) {
          attrMap = Object.fromEntries(resp.data.map((a) => [a.key, a.value]));
        } else {
          attrMap = resp.data;
        }
        const modbusConfig = attrMap['modbus_config'];

        setConfigName(modbusConfig?.name || '');
        setConfigId(modbusConfig?.id || '');

        // Get device type first
        const deviceType = attrMap.config_device_type
          ? Number(attrMap.config_device_type)
          : 1;
        setDeviceTypeKey(deviceType);

        if (attrMap.max_modbus_slave)
          setMaxSlavePerDevice(Number(attrMap.max_modbus_slave));
        if (attrMap.max_slave_per_interface)
          setMaxSlavePerInterFace(Number(attrMap.max_slave_per_interface));
        if (attrMap.max_modbus_params_per_slave)
          setMaxSlaveParameters(Number(attrMap.max_modbus_params_per_slave));
        if (!modbusConfig?.slave_list?.length) {
          console.warn('No slave_list found.');
          return;
        }

        const mergedConfigurations = modbusConfig.slave_list.map((slave) => {
          const config = slave.config || {};
          const meta = attrMap[slave.uuid] || {};

          return {
            id: slave.uuid,
            name: meta.name || config.name,
            slaveid: config.slaveid || '',
            slaveip: config.slaveip || '',
            interface_id: config.interface_id ?? 0,
            method: config.method?.toLowerCase() || '',
            port: config.port || '',
            baudrate: config.baudrate || 9600,
            timeout: config.timeout || 1000,
            parity: config.parity || 'N',
            stopbit: config.stopbit || 1,
            bytesize: config.bytesize || 8,
            pollperiod: config.pollperiod || 1000,
            host: config.host || '',
            parameters: (meta.parameters || []).map((param) => {
              const mappedParam = { ...param, id: param.id || uuidv4() };

              // Always create an 'access' field for the UI
              if (deviceType === 2) {
                // For GRIDX, the backend uses 'action' field
                mappedParam.access =
                  param.action !== undefined ? param.action : 0;
                // Keep original action for saving back
                mappedParam.action =
                  param.action !== undefined ? param.action : 0;
              } else {
                // For other types, the backend uses 'access' field
                mappedParam.access =
                  param.access !== undefined ? param.access : 0;
              }

              return mappedParam;
            }),
            model: '',
            make: '',
            type: '',
            protocol: '',
            version: slave.version,
          };
        });

        setConfigurations(mergedConfigurations);
        setOriginalData(() => {
          const data = {};
          mergedConfigurations.forEach((slave) => {
            data[slave.id] = JSON.parse(JSON.stringify(slave));
          });
          return data;
        });
      } catch (err) {
        console.error('Error loading configuration:', err);
      }
    },
    [groupID],
  );

  const fetchModbusConfigswithDevices = useCallback(() => {
    const keys = 'modbus_configs';
    setLoadingDevices(true);
    axiosInstance
      .get(apiUrls.fetchModbusConfigsandpatches(PLATFORM_ID, groupID, keys))
      .then((res) => {
        const configs = res.data.modbus_configs || [];
        const map = {};
        configs.forEach((cfg) => {
          map[cfg.id] = cfg.devices || [];
        });
        setConfigDeviceMap(map);
        const preselected = map[selectedModbusConfigId] || [];
        setPreselectedDevices(preselected);
      })
      .finally(() => {
        setLoadingDevices(false);
      });
  }, [PLATFORM_ID, groupID, selectedModbusConfigId]);

  const fetchInterfaces = useCallback(async () => {
    try {
      const keys = 'interfaces,modbus_configs,config_device_type';
      const resp = await axiosInstance.get(
        apiUrls.fetchModbusConfigsandpatches(PLATFORM_ID, groupID, keys),
      );
      let attrMap;
      if (Array.isArray(resp.data)) {
        attrMap = Object.fromEntries(resp.data.map((a) => [a.key, a.value]));
      } else {
        attrMap = resp.data;
      }

      setInterfaceList(attrMap.interfaces || []);

      const settingsMap = {};
      (attrMap.interfaces || []).forEach((iface) => {
        if (iface.interface) {
          settingsMap[iface.interface] = iface.settings || {};
        }
      });
      setInterfaceSettingsMap(settingsMap);

      const modbusConfigMap = {};
      (attrMap.modbus_configs || []).forEach((i) => {
        if (i.id && i.name) {
          modbusConfigMap[i.id] = i.name;
          modbusConfigMap[i.name] = i.id;
        }
      });
      setmodbusConfigMap(modbusConfigMap);

      if (urlConfigId) {
        setSelectedModbusConfigId(urlConfigId);
        await fetchModbusData(urlConfigId);
      }

      const interfaceIdMap = attrMap.interfaces.reduce((acc, i) => {
        const id = i.interface || '';
        const name = i.name || '';
        acc[name] = id;
        return acc;
      }, {});

      const interfaceNumberMap = attrMap.interfaces.reduce((acc, i) => {
        const id = i.id || '';
        const num = i.settings.interface;
        acc[id] = num;
        return acc;
      }, {});

      setInterfaceIdMap(interfaceIdMap);
      setInterfaceNumberMap(interfaceNumberMap);
    } catch (err) {
      console.error('Failed to fetch configurations', err);
    } finally {
      setLoading(false);
    }
  }, [deviceId, urlConfigId, fetchModbusData, groupID]);

  useEffect(() => {
    fetchInterfaces();
  }, [fetchInterfaces]);

  useEffect(() => {
    fetchModbusConfigswithDevices();
  }, [fetchModbusConfigswithDevices]);

  const addSlave = () => {
    if (configurations.length >= Number(maxSlavePerDevice)) {
      toast({
        title: 'Limit Exceeded',
        description: `You cannot add more than ${maxSlavePerDevice} slaves.`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    if (deviceTypeKey === 1 && configurations.length >= maxSlavePerDevice) {
      showError(
        `You cannot add more than ${maxSlavePerDevice} slaves for device type 1.`,
      );
      return;
    }

    if (deviceTypeKey === 2) {
      const interfaceCounts = configurations.reduce((acc, slave) => {
        acc[slave.interface_id] = (acc[slave.interface_id] || 0) + 1;
        return acc;
      }, {});

      const canAdd = Object.values(interfaceCounts).every(
        (count) => count < maxSlavePerInterFace,
      );

      if (!canAdd) {
        showError(
          `Each interface can only have ${maxSlavePerInterFace} slaves for device type 2.`,
        );
        return;
      }
    }

    const lastSlave = configurations[configurations.length - 1];
    const newSlave = {
      id: uuidv4(),
      name: '',
      slaveid: '',
      slaveip: '',
      interface_id: lastSlave ? lastSlave.interface_id : 0,
      parameters: [],
    };

    setConfigurations((prev) => [...prev, newSlave]);
    setOriginalData((prev) => ({ ...prev, [newSlave.id]: newSlave }));
  };

  const [pendingInterfaceChange, setPendingInterfaceChange] = useState({
    slaveId: null,
    newInterfaceId: null,
  });
  const [isInterfaceChangeDialogOpen, setIsInterfaceChangeDialogOpen] =
    useState(false);

  const updateSlave = (id, field, value) => {
    if (field === 'interface_id') {
      const slaveIndex = configurations.findIndex((slave) => slave.id === id);
      const currentSlave = configurations[slaveIndex];

      if (slaveIndex === 0) {
        setConfigurations((prev) =>
          prev.map((slave) =>
            slave.id === id
              ? {
                  ...slave,
                  [field]: value,
                }
              : slave,
          ),
        );
        return;
      }

      if (
        currentSlave &&
        currentSlave.interface_id &&
        currentSlave.interface_id !== 0 &&
        currentSlave.interface_id !== value
      ) {
        setPendingInterfaceChange({ slaveId: id, newInterfaceId: value });
        setIsInterfaceChangeDialogOpen(true);
        return;
      }
    }
    setConfigurations((prev) =>
      prev.map((slave) =>
        slave.id === id
          ? {
              ...slave,
              [field]: value,
            }
          : slave,
      ),
    );
  };

  const handleConfirmInterfaceChange = () => {
    const { slaveId, newInterfaceId } = pendingInterfaceChange;
    setConfigurations((prev) =>
      prev.map((slave) =>
        slave.id === slaveId
          ? {
              ...slave,
              interface_id: newInterfaceId,
            }
          : slave,
      ),
    );
    setIsInterfaceChangeDialogOpen(false);
    setPendingInterfaceChange({ slaveId: null, newInterfaceId: null });
  };

  const handleCancelInterfaceChange = () => {
    setIsInterfaceChangeDialogOpen(false);
    setPendingInterfaceChange({ slaveId: null, newInterfaceId: null });
  };

  const generateUniqueParamName = (slaveId, paramId, desiredName) => {
    if (!desiredName || !desiredName.trim()) return desiredName;

    const trimmedName = desiredName.trim();

    const allOtherParams = configurations
      .flatMap((slave) =>
        slave.id === slaveId
          ? slave.parameters
              .filter((p) => p.id !== paramId)
              .map((p) => p.name?.trim())
          : slave.parameters.map((p) => p.name?.trim()),
      )
      .filter(Boolean);

    if (!allOtherParams.includes(trimmedName)) {
      return desiredName;
    }

    let maxSuffix = 0;
    const baseNamePattern = new RegExp(`^${trimmedName}(?:_(\\d+))?$`);

    allOtherParams.forEach((existingName) => {
      const match = existingName.match(baseNamePattern);
      if (match) {
        const suffix = match[1] ? parseInt(match[1], 10) : 0;
        maxSuffix = Math.max(maxSuffix, suffix);
      }
    });

    return `${trimmedName}_${maxSuffix + 1}`;
  };

  const addParameter = (slaveId) => {
    const targetSlave = configurations.find((s) => s.id === slaveId);
    if (!targetSlave) return;

    if (targetSlave.parameters.length >= Number(maxSlaveParameters)) {
      toast({
        title: 'Limit Exceeded',
        description: `You cannot add more than ${maxSlaveParameters} parameters per slave.`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    let paramName = defaultParameter.name;
    if (paramName && paramName.trim()) {
      paramName = generateUniqueParamName(slaveId, null, paramName);
    }

    const param = {
      ...defaultParameter,
      id: uuidv4(),
      name: paramName,
    };

    setConfigurations((prev) =>
      prev.map((slave) =>
        slave.id === slaveId
          ? { ...slave, parameters: [...slave.parameters, param] }
          : slave,
      ),
    );

    setParamPages((prev) => {
      const newParamCount = (targetSlave.parameters.length || 0) + 1;
      const lastPage = Math.floor((newParamCount - 1) / 10);
      return { ...prev, [slaveId]: lastPage };
    });
  };

  const updateParameter = (slaveId, paramId, field, value, isFinal = false) => {
    if (field === 'name' && value && !/^[A-Za-z]/.test(value.trim())) {
      toast({
        title: 'Invalid Parameter Name',
        description:
          'The first letter of the parameter name must be an alphabet.',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    const numericFields = [
      'fn_code',
      'address',
      'factor',
      'register_count',
      'offset',
    ];
    if (numericFields.includes(field) && Number(value) < 0) {
      toast({
        title: 'Invalid Value',
        description: `${field.replace('_', ' ')} cannot be negative.`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }
    setConfigurations((prev) =>
      prev.map((slave) => {
        if (slave.id !== slaveId) return slave;
        return {
          ...slave,
          parameters: slave.parameters.map((param) => {
            if (param.id !== paramId) return param;

            if (field === 'name' && isFinal && value && value.trim()) {
              const uniqueName = generateUniqueParamName(
                slaveId,
                paramId,
                value,
              );
              return { ...param, [field]: uniqueName };
            }

            return { ...param, [field]: value };
          }),
        };
      }),
    );
  };

  const [deleteTarget, setDeleteTarget] = useState({
    type: null,
    slaveId: null,
    paramId: null,
  });
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  function isValidIPv4(ip) {
    return /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.|$)){4}$/.test(ip);
  }

  function isValidIPv6(ip) {
    return /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::1)$|^(([0-9a-fA-F]{1,4}:){1,7}:)$|^(:{2}([0-9a-fA-F]{1,4}:){0,5}[0-9a-fA-F]{1,4})$/.test(
      ip,
    );
  }

  function isValidIP(ip) {
    return isValidIPv4(ip) || isValidIPv6(ip);
  }

  const isSlaveConfigValid = (slave) => {
    if (!slave.name || !slave.name.trim()) return false;
    if (!slave.slaveid || slave.slaveid === '') return false;
    if (!slave.interface_id || slave.interface_id === 0) return false;
    const interfaceName = getInterfaceNameById(slave.interface_id);
    if (interfaceName === 'Modbus_TCP') {
      if (!slave.slaveip || !slave.slaveip.trim()) return false;
      if (!isValidIP(slave.slaveip.trim())) return false;
    }
    if (slave.parameters.some((param) => !param.name || !param.name.trim()))
      return false;
    return true;
  };

  const handleSave = (slave) => {
    const interfaceName = getInterfaceNameById(slave.interface_id);
    if (interfaceName === 'Modbus_TCP') {
      if (!slave.slaveip || !slave.slaveip.trim()) {
        toast({
          title: 'Validation Error',
          description: 'Slave IP is required for Modbus_TCP interface.',
          status: 'error',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });
        return;
      }
      if (!isValidIP(slave.slaveip.trim())) {
        toast({
          title: 'Invalid IP Address',
          description:
            'Please enter a valid IPv4 or IPv6 address for Slave IP.',
          status: 'error',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });
        return;
      }
    }
    if (!isSlaveConfigValid(slave)) {
      toast({
        title: 'Validation Error',
        description:
          'Please fill all required fields (slave name, slave id, interface, and parameter names).',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    setConfigurations((prev) => {
      const index = prev.findIndex((s) => s.id === slave.id);

      let newVersion;

      if (index === -1) {
        const versions = prev.map((s) => s.version || 1);
        const maxVersion = versions.length ? Math.max(...versions) : 0;
        newVersion = maxVersion + 1;
      } else {
        const existingSlave = prev[index];
        const original = originalData[slave.id];

        if (original && JSON.stringify(slave) !== JSON.stringify(original)) {
          newVersion = (existingSlave.version || 1) + 1;
        } else {
          newVersion = existingSlave.version || 1;
        }
      }

      const updatedSlave = {
        ...slave,
        version: newVersion,
      };

      toast({
        title: 'Slave Saved.',
        description: `Slave ${
          slave.name || slave.id
        } added to the device configuration.`,
        status: 'success',
        duration: 2000,
        position: 'top',
        isClosable: true,
      });

      setOriginalData((prevOriginal) => ({
        ...prevOriginal,
        [slave.id]: JSON.parse(JSON.stringify(updatedSlave)),
      }));

      if (index !== -1) {
        const updated = [...prev];
        updated[index] = updatedSlave;
        return updated;
      } else {
        return [...prev, updatedSlave];
      }
    });
  };

  const handleSaveConfigurations = async () => {
    const unsavedSlaves = configurations.filter((slave) =>
      isSlaveChanged(slave),
    );
    if (unsavedSlaves.length > 0) {
      toast({
        title: 'Unsaved Changes',
        description:
          'Please save all slaves individually before saving the configuration.',
        status: 'warning',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    try {
      let existingSlaveVersions = {};
      let serverMaxVersion = 0;

      try {
        const resp = await axiosInstance.get(
          apiUrls.toolDeviceAttributesV1(
            PLATFORM_ID,
            groupID,
            modbusId,
            'modbus_config,modbus_config_v',
          ),
        );
        let attrMap;
        if (Array.isArray(resp.data)) {
          attrMap = Object.fromEntries(resp.data.map((a) => [a.key, a.value]));
        } else {
          attrMap = resp.data;
        }
        const modbusConfig = attrMap['modbus_config'];

        if (modbusConfig?.slave_list?.length) {
          modbusConfig.slave_list.forEach((slave) => {
            if (slave.uuid) {
              existingSlaveVersions[slave.uuid] = slave.version || 1;
              serverMaxVersion = Math.max(serverMaxVersion, slave.version || 1);
            }
          });
        }
      } catch (err) {
        console.error('Error fetching modbus_config for versioning', err);
      }

      const slavesConfigWithVersions = configurations.map((slave) => {
        const isNew = !existingSlaveVersions.hasOwnProperty(slave.id);
        const original = originalData[slave.id];
        const isChanged = original
          ? JSON.stringify(slave) !== JSON.stringify(original)
          : true;

        let version;

        if (slave.version && !isNew) {
          version = slave.version;
        } else if (isNew) {
          const allCurrentVersions = configurations
            .filter((s) => !isNew || s.id !== slave.id)
            .map((s) => s.version || 1);
          const maxCurrentVersion = Math.max(
            ...allCurrentVersions,
            serverMaxVersion,
            0,
          );
          version = maxCurrentVersion + 1;
        } else if (isChanged) {
          version = (existingSlaveVersions[slave.id] || 1) + 1;
        } else {
          version = existingSlaveVersions[slave.id] || 1;
        }

        const cleanedParameters = slave.parameters.map((param) => {
          const { id, access, fromAssetParamDialog, ...restWithoutId } = param;
          if (deviceTypeKey === 2) {
            return {
              ...restWithoutId,
              action: access || 0,
            };
          } else {
            const {
              register_count,
              register_data_type,
              offset,
              write_fn_code,
              ...rest
            } = restWithoutId;
            return {
              ...rest,
              access: access || 0,
            };
          }
        });

        const interfaceName = getInterfaceNameById(slave.interface_id);
        const isModbusTCP = interfaceName === 'Modbus_TCP';

        let slavePayload = {
          interface_id: slave?.interface_id,
          id: slave?.id || '',
          version,
          slave_id: slave?.slaveid || '',
          slave_name: slave?.name || '',
          parameters: cleanedParameters,
        };

        if (isModbusTCP) {
          let slave_ip =
            slave.slaveip !== undefined ? String(slave.slaveip) : '';
          slavePayload.slave_ip = slave_ip;
        }

        return slavePayload;
      });

      const modbusConfigPayload = {
        apply_to_devices: 0,
        config_id: configId,
        config_name: configName,
        config_device_type: deviceTypeKey,
        slaves_config: slavesConfigWithVersions,
      };

      const response = await axiosInstance.post(
        apiUrls.updateConfig(PLATFORM_ID, groupID),
        modbusConfigPayload,
      );

      if (response.status === 200) {
        const updatedOriginals = {};
        configurations.forEach((slave) => {
          updatedOriginals[slave.id] = JSON.parse(JSON.stringify(slave));
        });

        setOriginalData(updatedOriginals);

        toast({
          title: `Configuration Saved`,
          description:
            response.data.success || 'Configuration saved successfully',
          status: 'success',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });

        if (selectedModbusConfigId) {
          await fetchModbusData(selectedModbusConfigId);
        }
      } else {
        throw new Error('Unexpected response status');
      }
    } catch (err) {
      console.error('Save failed:', err);
      toast({
        title: 'Save Failed',
        description: 'Could not save the configurations. Please try again.',
        status: 'error',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleSaveConfigurations2 = async () => {
    try {
      let existingSlaveVersions = {};
      let serverMaxVersion = 0;

      try {
        const resp = await axiosInstance.get(
          apiUrls.toolDeviceAttributes(
            deviceId,
            'modbus_config,modbus_config_v',
          ),
        );
        const attrMap = Object.fromEntries(
          resp.data.map((a) => [a.key, a.value]),
        );
        const modbusConfig = attrMap['modbus_config'];

        if (modbusConfig?.slave_list?.length) {
          modbusConfig.slave_list.forEach((slave) => {
            if (slave.uuid) {
              existingSlaveVersions[slave.uuid] = slave.version || 1;
              serverMaxVersion = Math.max(serverMaxVersion, slave.version || 1);
            }
          });
        }
      } catch (err) {
        console.error('Error fetching modbus_config for versioning', err);
      }

      const slavesConfigWithVersions = configurations.map((slave) => {
        const isNew = !existingSlaveVersions.hasOwnProperty(slave.id);
        const original = originalData[slave.id];
        const isChanged = original
          ? JSON.stringify(slave) !== JSON.stringify(original)
          : true;

        let version;

        if (slave.version && !isNew) {
          version = slave.version;
        } else if (isNew) {
          const allCurrentVersions = configurations
            .filter((s) => !isNew || s.id !== slave.id)
            .map((s) => s.version || 1);
          const maxCurrentVersion = Math.max(
            ...allCurrentVersions,
            serverMaxVersion,
            0,
          );
          version = maxCurrentVersion + 1;
        } else if (isChanged) {
          version = (existingSlaveVersions[slave.id] || 1) + 1;
        } else {
          version = existingSlaveVersions[slave.id] || 1;
        }

        const cleanedParameters = slave.parameters.map((param) => {
          const { id, fromAssetParamDialog, ...restWithoutId } = param;
          if (deviceTypeKey === 2) {
            const { access, ...rest } = restWithoutId;
            return {
              ...rest,
              action: param.action || 0,
            };
          } else {
            const {
              action,
              register_count,
              register_data_type,
              offset,
              write_fn_code,
              ...rest
            } = restWithoutId;
            return {
              ...rest,
              access: param.access || 0,
            };
          }
        });

        const interfaceName = getInterfaceNameById(slave.interface_id);
        const isModbusTCP = interfaceName === 'Modbus_TCP';

        let slavePayload = {
          interface_id: slave?.interface_id,
          id: slave?.id || '',
          version,
          slave_id: slave?.slaveid || '',
          slave_name: slave?.name || '',
          parameters: cleanedParameters,
        };

        if (isModbusTCP) {
          let slave_ip =
            slave.slaveip !== undefined ? String(slave.slaveip) : '';
          slavePayload.slave_ip = slave_ip;
        }

        return slavePayload;
      });

      const modbusConfigPayload = {
        addConfigToDevice: 1,
        config_id: configId,
        config_name: configName,
        slaves_config: slavesConfigWithVersions,
      };
      handleSaveConfigurations();
      const allDeviceIds = Array.from(new Set(selectedDevices.filter(Boolean)));

      let successCount = 0;
      let failCount = 0;
      const failedDevices = [];

      for (const dId of allDeviceIds) {
        try {
          const response = await axiosInstance.post(
            apiUrls.updateDeviceModbus(dId),
            modbusConfigPayload,
          );

          if (response.status === 200) {
            successCount++;
          } else {
            failCount++;
            failedDevices.push(dId);
          }
        } catch (err) {
          console.error(`Error saving config for device ${dId}:`, err);
          failCount++;
          failedDevices.push(dId);
        }
      }

      if (successCount > 0) {
        const updatedOriginals = {};
        configurations.forEach((slave) => {
          updatedOriginals[slave.id] = JSON.parse(JSON.stringify(slave));
        });
        setOriginalData(updatedOriginals);
        fetchModbusConfigswithDevices();
        fetchModbusData(selectedModbusConfigId);

        toast({
          title: 'Configuration Saved',
          description: `Successfully published to ${successCount} device(s).`,
          status: 'success',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });
      }

      if (failCount > 0) {
        toast({
          title: 'Some Devices Failed',
          description: `Failed to publish to ${failCount} device(s): ${failedDevices.join(', ')}`,
          status: 'error',
          duration: 5000,
          position: 'top',
          isClosable: true,
        });
      }

      onCloseSaveConf();
      navigate('/modbus-configs');
    } catch (err) {
      console.error('Save failed:', err);
      toast({
        title: 'Save Failed',
        description: 'Could not save the configurations. Please try again.',
        status: 'error',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (
      selectedModbusConfigId &&
      Object.values(modbusConfigMap).includes(selectedModbusConfigId)
    ) {
      fetchModbusData(selectedModbusConfigId);
    }
  }, [selectedModbusConfigId, modbusConfigMap, fetchModbusData]);

  const updateSlaveParams = (parameters) => {
    if (!currentSlaveId || !parameters || !Array.isArray(parameters)) {
      console.error('Invalid parameters or no slave selected');
      return;
    }

    setConfigurations((prev) =>
      prev.map((slave) => {
        if (slave.id === currentSlaveId) {
          const newParameters = parameters.map((param) => {
            const uniqueName = generateUniqueParamName(
              currentSlaveId,
              null,
              param.name,
            );

            const paramType =
              typeof param.type === 'number'
                ? param.type
                : (ParamTypes[param.type] ?? 43);

            let writeFnCode = -1;
            if (typeof param.write_fn_code === 'number') {
              writeFnCode = param.write_fn_code;
            } else if (
              typeof param.writeFn === 'string' &&
              writeFunctionCodes[param.writeFn] !== undefined
            ) {
              writeFnCode = writeFunctionCodes[param.writeFn];
            }

            const accessValue =
              param.action !== undefined
                ? param.action
                : typeof param.access === 'number'
                  ? param.access
                  : (Actions[param.access] ?? 0);

            return {
              id: param.id || uuidv4(),
              name: uniqueName,
              fn_code: param.fn_code || param.fnCode || 3,
              address: param.address || 0,
              type: paramType,
              factor: param.factor || 1,
              register_count: param.register_count || param.regCount || 1,
              register_data_type:
                typeof param.register_data_type === 'number'
                  ? param.register_data_type
                  : RegisterDataType[param.regDataType] || 1,
              offset: param.offset || 0,
              write_fn_code: writeFnCode,
              access: accessValue,
            };
          });

          return {
            ...slave,
            parameters: [...slave.parameters, ...newParameters],
          };
        }
        return slave;
      }),
    );
  };

  const showAllColumns = deviceTypeKey === 2;
  const [expandedSlaves, setExpandedSlaves] = useState({});
  const [paramPages, setParamPages] = useState({});

  const getPaginatedParameters = (slave) => {
    const page = paramPages[slave.id] || 0;
    const pageSize = 10;
    const start = page * pageSize;
    const end = start + pageSize;
    return slave.parameters.slice(start, end);
  };

  const getTotalPages = (slave) => {
    return Math.ceil((slave.parameters?.length || 0) / 10);
  };

  const handleParamPageChange = (slaveId, newPage) => {
    setParamPages((prev) => ({
      ...prev,
      [slaveId]: newPage,
    }));
  };

  useEffect(() => {
    if (configurations.length > 0) {
      const allExpanded = {};
      configurations.forEach((slave) => {
        allExpanded[slave.id] = true;
      });
      setExpandedSlaves(allExpanded);
    }
  }, [configurations]);

  const getInterfaceNameById = (interface_id) => {
    const iface = interfaceList.find((i) => i.interface === interface_id);
    return iface ? iface.name : '';
  };

  const getDeviceTypeDisplay = (key) => deviceTypeDisplayMap[key] || '';

  const handleDeviceTypeChange = (val) => {
    const num = deviceTypeReverseMap[val];
    if (num) {
      setDeviceTypeKey(num);

      const allowedInterfaces = getFilteredInterfaces(num);
      const allowedIds = allowedInterfaces.map((iface) => iface.interface);

      setConfigurations((prev) =>
        prev.map((slave) => {
          if (!allowedIds.includes(slave.interface_id)) {
            return { ...slave, interface_id: allowedIds[0] || 0 };
          }
          return slave;
        }),
      );
    }
  };

  const handleAddThreshold = () => {
    if (!selectedThresholdParam) return;

    const min = Number(minThreshold);
    const max = Number(maxThreshold);

    if (isNaN(min) || isNaN(max)) {
      toast({
        title: 'Invalid Threshold',
        description: 'Both min and max thresholds must be valid numbers.',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }
    if (min >= max) {
      toast({
        title: 'Invalid Threshold',
        description: 'Min threshold must be less than Max threshold.',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    const { slave, param } = selectedThresholdParam;
    setConfigurations((prev) =>
      prev.map((s) =>
        s.id === slave.id
          ? {
              ...s,
              parameters: s.parameters.map((p) =>
                p.id === param.id
                  ? {
                      ...p,
                      thresholds: [
                        {
                          min: minThreshold,
                          max: maxThreshold,
                        },
                      ],
                    }
                  : p,
              ),
            }
          : s,
      ),
    );
    setThresholdModalOpen(false);
  };

  const handleApplyToDevices = async () => {
    let existingSlaveVersions = {};
    let serverMaxVersion = 0;

    try {
      const resp = await axiosInstance.get(
        apiUrls.toolDeviceAttributesV1(
          PLATFORM_ID,
          groupID,
          modbusId,
          'modbus_config,modbus_config_v',
        ),
      );
      let attrMap;
      if (Array.isArray(resp.data)) {
        attrMap = Object.fromEntries(resp.data.map((a) => [a.key, a.value]));
      } else {
        attrMap = resp.data;
      }
      const modbusConfig = attrMap['modbus_config'];
      if (modbusConfig?.slave_list?.length) {
        modbusConfig.slave_list.forEach((slave) => {
          existingSlaveVersions[slave.id] = slave.version || 1;
          if (slave.version && slave.version > serverMaxVersion) {
            serverMaxVersion = slave.version;
          }
        });
      }
    } catch (err) {
      const errorMsg =
        err?.response?.data?.message || err?.message || 'Something went wrong';

      toast({
        title: 'Error',
        description: errorMsg,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
    }

    const slavesConfigWithVersions = configurations.map((slave) => {
      const isNew = !existingSlaveVersions.hasOwnProperty(slave.id);
      const original = originalData[slave.id];
      const isChanged = original
        ? JSON.stringify(slave) !== JSON.stringify(original)
        : true;

      let version;
      if (slave.version && !isNew) {
        version = slave.version;
      } else if (isNew) {
        version = serverMaxVersion + 1;
      } else {
        version = existingSlaveVersions[slave.id] + (isChanged ? 1 : 0);
      }

      const cleanedParameters = slave.parameters.map((param) => {
        const { id, fromAssetParamDialog, ...restWithoutId } = param;
        if (deviceTypeKey === 2) {
          const { access, ...rest } = restWithoutId;
          return {
            ...rest,
            action: param.action || 0,
          };
        } else {
          const {
            action,
            register_count,
            register_data_type,
            offset,
            write_fn_code,
            ...rest
          } = restWithoutId;
          return {
            ...rest,
            access: param.access || 0,
          };
        }
      });

      const interfaceName = getInterfaceNameById(slave.interface_id);
      const isModbusTCP = interfaceName === 'Modbus_TCP';

      let slavePayload = {
        interface_id: slave?.interface_id,
        id: slave?.id || '',
        version,
        slave_id: slave?.slaveid || '',
        slave_name: slave?.name || '',
        parameters: cleanedParameters,
      };

      if (isModbusTCP) {
        slavePayload.slaveip = slave.slaveip;
      }

      return slavePayload;
    });

    const modbusConfigPayload = {
      apply_to_devices: 1,
      config_id: configId,
      config_name: configName,
      config_device_type: deviceTypeKey,
      slaves_config: slavesConfigWithVersions,
    };

    try {
      const response = await axiosInstance.post(
        apiUrls.updateConfig(PLATFORM_ID, groupID),
        modbusConfigPayload,
      );

      if (response.status === 200) {
        toast({
          title: 'Configuration Applied',
          description: 'Configuration applied successfully',
          status: 'success',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });
      } else {
        throw new Error('Unexpected response status');
      }
    } catch (err) {
      toast({
        title: 'Apply Failed',
        description:
          err?.response?.data?.message ||
          err?.message ||
          'Could not apply the configuration.',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
    }
  };
  const toggleSlaveExpand = (slaveId) => {
    setExpandedSlaves((prev) => ({
      ...prev,
      [slaveId]: !prev[slaveId],
    }));
  };
  const getFilteredInterfaces = (type = deviceTypeKey) => {
    if (type === 1 || type === 3) {
      return interfaceList.filter(
        (iface) =>
          iface.name === 'Modbus_RS485_1' || iface.name === 'Modbus_TCP',
      );
    }
    return interfaceList;
  };

  const onOpenSaveConf = () => {
    const navDevices = location.state?.devices || [];

    let devicesToPreselect = [];

    if (navDevices.length > 0) {
      devicesToPreselect =
        typeof navDevices[0] === 'object'
          ? navDevices.map((d) => d.device_id || d.id)
          : navDevices;
    }

    const allPreselected =
      devicesToPreselect.length > 0 ? devicesToPreselect : [];
    setSelectedDevices(allPreselected);
    setSearchType('deviceId');
    setSelectedCluster('');
    setStateOptions([]);
    setSelectedState('');
    setNocOptions([]);
    setSelectedNoc('');
    setPlantOptions([]);
    setSelectedPlant('');
    setDevicesArray([]);
    setSerialNumber('');
    setCurrentPage(-1);
    DeviceSaveConf();
    fetchAllDevices('', true, 0);
    setPreselectedDeviceIds(allPreselected);
  };

  const handleCheckboxChange = (id) => {
    setSelectedDevices((prev) => {
      if (prev.includes(id)) {
        setSelectAllFlag(false);
        return prev.filter((d) => d !== id);
      }
      return [...prev, id];
    });
  };

  const fetchCountries = async () => {
    try {
      const resp = await axiosInstance.get(apiUrls.getCountries());
      const options = (resp.data?.data || []).map((item) => ({
        label: item.name,
        value: item.id.id,
      }));
      setClusterOptions(options);
    } catch {
      setClusterOptions([]);
    }
  };

  const fetchStates = async (countryId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(countryId));
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setStateOptions(options);
    } catch {
      setStateOptions([]);
    }
  };

  const fetchNocs = async (stateId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(stateId));
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setNocOptions(options);
    } catch {
      setNocOptions([]);
    }
  };

  const fetchPlants = async (nocId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(nocId));
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setPlantOptions(options);
    } catch {
      setPlantOptions([]);
    }
  };

  const fetchClusterDevices = async (id) => {
    setLoadingDevices(true);
    try {
      const token = Cookies.get('authToken');
      const resp = await fetch(apiUrls.getClusterDevices(id), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      if (!resp.ok) throw new Error('Network response was not ok');
      const data = await resp.json();

      const devicesNameIdMap = (data?.devices || []).map((d) => ({
        id: String(d.id),
        name: d.name,
      }));
      setDevicesArray(devicesNameIdMap);

      // IMPORTANT: Only preselect devices from navigation, NOT from preselectedDevices
      const navDevices = location.state?.devices || [];
      const devicesToPreselect = navDevices.map(
        (device) => device.device_id || device.id,
      );

      // Filter devices that exist in the current devicesArray and are in navigation
      const preselected = devicesNameIdMap
        .filter(
          (d) =>
            devicesToPreselect.includes(d.id) ||
            devicesToPreselect.includes(d.name),
        )
        .map((d) => d.id);

      // Don't automatically include deviceId - only include navigation devices
      setSelectedDevices(preselected);
    } catch (err) {
      setDevicesArray([]);
      setSelectedDevices([]);
      console.error('Failed to fetch cluster devices:', err);
    } finally {
      setLoadingDevices(false);
    }
  };

  useEffect(() => {
    if (selectedCluster) {
      fetchStates(selectedCluster);
      setSelectedState('');
      setNocOptions([]);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      setDevicesArray([]);
      fetchClusterDevices(selectedCluster);
    }
  }, [selectedCluster]);

  useEffect(() => {
    if (selectedState) {
      fetchNocs(selectedState);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      setDevicesArray([]);
      fetchClusterDevices(selectedState);
    }
  }, [selectedState]);

  useEffect(() => {
    if (selectedNoc) {
      fetchPlants(selectedNoc);
      setSelectedPlant('');
      setDevicesArray([]);
      fetchClusterDevices(selectedNoc);
    }
  }, [selectedNoc]);

  useEffect(() => {
    if (selectedPlant) {
      setLoadingDevices(true);
      fetchClusterDevices(selectedPlant);
    }
  }, [selectedPlant]);

  useEffect(() => {
    if (searchType === 'cluster') {
      fetchCountries();
      setSelectedDevices(
        preselectedDevices.length > 0
          ? Array.from(new Set([...preselectedDevices, deviceId]))
          : [deviceId],
      );
      setSelectedCluster('');
      setStateOptions([]);
      setSelectedState('');
      setNocOptions([]);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      setDevicesArray([]);
      setSerialNumber('');
      setCurrentPage(-1);
    }
  }, [searchType]);

  useEffect(() => {
    if (searchType === 'deviceId') {
      setSelectedDevices(
        Array.from(new Set([...preselectedDevices, deviceId])),
      );
    }
  }, [searchType, preselectedDevices]);
  useEffect(() => {
    if (searchType === 'deviceId') {
      setDevicesArray([]); // Reset device list
      setCurrentPage(0); // Reset pagination
      fetchAllDevices(serialNumber, true, 0); // Fetch devices
    }
  }, [searchType]);

  return (
    <>
      {loading ? (
        <TableSkeleton rowCount={5} columnCount={12} />
      ) : (
        <Box ml={1} mt={6} color={textColor} pb={32}>
          <BreadCrumb items={breadcrumbItems} sidebarWidth={sidebarWidth} />

          <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
          <Flex
            ml={sidebarWidth}
            justify="space-between"
            mr={5}
            align="center"
            gap={2}
          >
            <Heading size="lg" mb={6} ml={2}>
              {modbusConfigMap[urlConfigId] || ''}
            </Heading>
            <Flex align="center" gap={2}>
              <Text mr={2} fontWeight="600">
                Device Type:{' '}
              </Text>
              <Flex align="center" gap={2}>
                <InterfaceSelect
                  value={getDeviceTypeDisplay(deviceTypeKey)}
                  options={Object.keys(deviceTypeReverseMap)}
                  onChange={handleDeviceTypeChange}
                  disabled={!isTenantAdmin}
                />
              </Flex>

              <Flex align="center" gap={2}>
                {isTenantAdmin && status !== 'published' && (
                  <Button
                    size="sm"
                    colorScheme="green"
                    variant="outline"
                    border="2px"
                    cursor="pointer"
                    onClick={handleSaveConfigurations}
                    ml={1}
                  >
                    Save as Draft
                  </Button>
                )}
              </Flex>
              <Flex align="center" gap={2}>
                {isTenantAdmin && (
                  <Button
                    size="sm"
                    colorScheme="green"
                    variant="outline"
                    border="2px"
                    cursor="pointer"
                    onClick={() => {
                      onOpenSaveConf();
                      setCurrentPage(0);
                      setDevicesArray([]);
                      setSearchType('deviceId');
                    }}
                    ml={1}
                    // isDisabled={!(status === 'published' && isActive === true)}
                  >
                    Publish
                  </Button>
                )}
              </Flex>
            </Flex>
          </Flex>
          {configurations.map((slave) => {
            const interfaceName = getInterfaceNameById(slave.interface_id);
            const isModbusTCP = interfaceName === 'Modbus_TCP';
            return (
              <Card
                ml={sidebarWidth}
                key={slave.id}
                bg={cardBg}
                p={4}
                my={4}
                width={`calc(100% - ${sidebarWidth} - 20px)`}
                mr="32px"
                color={textColor}
              >
                <Table size="sm" mb={4}>
                  <Thead>
                    <Tr>
                      <Th textAlign={'center'} borderColor="transparent">
                        Name
                      </Th>
                      <Th textAlign={'center'} borderColor="transparent">
                        Slave ID
                      </Th>
                      {isModbusTCP && (
                        <>
                          <Th textAlign={'center'} borderColor="transparent">
                            Slave IP
                          </Th>
                        </>
                      )}
                      <Th textAlign={'center'} borderColor="transparent">
                        Interface
                      </Th>
                      <Th borderColor="transparent" textAlign="center" />
                      <Th borderColor="transparent" textAlign="center" />
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td borderColor="transparent" ps={0}>
                        <Default
                          size="sm"
                          fontSize="lg"
                          placeholder="slave name"
                          value={slave.name}
                          onChange={(e) =>
                            updateSlave(slave.id, 'name', e.target.value)
                          }
                          bg={inputBg}
                          color={textColor}
                          isDisabled={!isTenantAdmin}
                        />
                      </Td>
                      <Td borderColor="transparent" ps={0}>
                        <Tooltip
                          label="Slave ID must be a positive number greater than 0"
                          isOpen={invalidSlaveIds[slave.id] || false}
                          placement="top"
                          hasArrow
                          bg="red.500"
                          color="white"
                        >
                          <Box>
                            <Default
                              size="sm"
                              fontSize="md"
                              type="number"
                              placeholder="slave id"
                              value={slave.slaveid}
                              onKeyDown={(e) => {
                                if (
                                  ['e', 'E', '+', '-', '.', ' '].includes(e.key)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === '' || /^[1-9][0-9]*$/.test(val)) {
                                  updateSlave(
                                    slave.id,
                                    'slaveid',
                                    val === '' ? '' : Number(val),
                                  );
                                  setInvalidSlaveIds((prev) => ({
                                    ...prev,
                                    [slave.id]: false,
                                  }));
                                } else {
                                  setInvalidSlaveIds((prev) => ({
                                    ...prev,
                                    [slave.id]: true,
                                  }));
                                }
                              }}
                              bg={inputBg}
                              color={textColor}
                              isDisabled={!isTenantAdmin}
                            />
                          </Box>
                        </Tooltip>
                      </Td>
                      {isModbusTCP && (
                        <>
                          <Td borderColor="transparent" ps={0}>
                            <Default
                              size="sm"
                              fontSize="md"
                              placeholder="slave ip"
                              value={slave.slaveip}
                              onChange={(e) =>
                                updateSlave(slave.id, 'slaveip', e.target.value)
                              }
                              bg={inputBg}
                              color={textColor}
                              isDisabled={!isTenantAdmin}
                            />
                          </Td>
                        </>
                      )}
                      <Td borderColor="transparent" ps={0}>
                        <InterfaceSelect
                          value={slave.interface_id}
                          options={getFilteredInterfaces().map((iface) => ({
                            label: iface.name,
                            value: iface.interface,
                          }))}
                          onChange={(selectedInterface) => {
                            updateSlave(
                              slave.id,
                              'interface_id',
                              selectedInterface,
                            );
                          }}
                          disabled={!isTenantAdmin}
                        />
                      </Td>
                      <Td borderColor="transparent" textAlign="center" ps={0}>
                        {slave.parameters && slave.parameters.length > 0 && (
                          <Button
                            size="sm"
                            onClick={() => toggleSlaveExpand(slave.id)}
                            leftIcon={
                              expandedSlaves[slave.id] ? (
                                <ChevronDownIcon />
                              ) : (
                                <ChevronRightIcon />
                              )
                            }
                          />
                        )}
                      </Td>
                      <Td borderColor="transparent" textAlign="center" ps={0}>
                        {isTenantAdmin && (
                          <IconButton
                            aria-label="Remove slave"
                            icon={<DeleteIcon />}
                            size="sm"
                            colorScheme="red"
                            onClick={() => confirmDelete('slave', slave.id)}
                            isDisabled={!isTenantAdmin}
                          />
                        )}
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>

                <HSeparator />

                {expandedSlaves[slave.id] && slave.parameters.length > 0 && (
                  <Box overflowX="auto" maxWidth="100%">
                    <Table variant="simple" size="sm" mt={4}>
                      <Thead>
                        <Tr>
                          <Th borderColor="transparent" textAlign="center">
                            Name
                          </Th>
                          <Th borderColor="transparent" textAlign="center">
                            Fn Code
                          </Th>
                          <Th borderColor="transparent" textAlign="center">
                            Address
                          </Th>
                          <Th borderColor="transparent" textAlign="center">
                            Type
                          </Th>
                          <Th borderColor="transparent" textAlign="center">
                            Factor
                          </Th>
                          {showAllColumns && (
                            <Th borderColor="transparent" textAlign="center">
                              Reg Count
                            </Th>
                          )}
                          {showAllColumns && (
                            <Th borderColor="transparent" textAlign="center">
                              Register Data Type
                            </Th>
                          )}
                          {showAllColumns && (
                            <Th borderColor="transparent" textAlign="center">
                              Offset
                            </Th>
                          )}
                          {showAllColumns && (
                            <Th borderColor="transparent" textAlign="center">
                              Write Fn
                            </Th>
                          )}
                          <Th borderColor="transparent" textAlign="center">
                            Access
                          </Th>
                          <Th borderColor="transparent" textAlign="center">
                            Threshold
                          </Th>
                          {isTenantAdmin && (
                            <Th borderColor="transparent" textAlign="center">
                              Delete
                            </Th>
                          )}
                        </Tr>
                      </Thead>
                      <Tbody>
                        {getPaginatedParameters(slave).map((param, idx) => (
                          <Tr key={param.id || idx}>
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <Default
                                size="sm"
                                placeholder="e.g. tmp"
                                value={param.name}
                                onChange={(e) =>
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'name',
                                    e.target.value,
                                    false,
                                  )
                                }
                                onBlur={(e) =>
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'name',
                                    e.target.value,
                                    true,
                                  )
                                }
                                bg={inputBg}
                                color={textColor}
                                isDisabled={true || !isTenantAdmin}
                              />
                            </Td>
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <Default
                                size="sm"
                                type="number"
                                value={param.fn_code}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val === '') {
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'fn_code',
                                      '',
                                    );
                                    return;
                                  }
                                  const num = Number(val);
                                  if ([1, 2, 3, 4].includes(num)) {
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'fn_code',
                                      num,
                                    );
                                  }
                                }}
                                min={1}
                                max={4}
                                bg={inputBg}
                                color={textColor}
                                isDisabled={!isTenantAdmin}
                              />
                            </Td>
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <Default
                                size="sm"
                                type="number"
                                value={param.address}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'address',
                                    val === '' ? '' : Number(val),
                                  );
                                }}
                                bg={inputBg}
                                color={textColor}
                                isDisabled={!isTenantAdmin}
                              />
                            </Td>
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <InterfaceSelect
                                value={param.type}
                                options={ParamTypes}
                                onChange={(val) =>
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'type',
                                    val,
                                  )
                                }
                                disabled={!isTenantAdmin}
                              />
                            </Td>
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <Default
                                size="sm"
                                type="number"
                                value={param.factor}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'factor',
                                    val === '' ? '' : Number(val),
                                  );
                                }}
                                bg={inputBg}
                                color={textColor}
                                isDisabled={!isTenantAdmin}
                              />
                            </Td>
                            {showAllColumns && (
                              <Td
                                ps={0}
                                borderColor="transparent"
                                textAlign="center"
                              >
                                <Default
                                  size="sm"
                                  type="number"
                                  value={param.register_count}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'register_count',
                                      val === '' ? '' : Number(val),
                                    );
                                  }}
                                  bg={inputBg}
                                  color={textColor}
                                  isDisabled={!isTenantAdmin}
                                />
                              </Td>
                            )}
                            {showAllColumns && (
                              <Td
                                ps={0}
                                borderColor="transparent"
                                textAlign="center"
                              >
                                <InterfaceSelect
                                  value={param.register_data_type}
                                  options={RegisterDataType}
                                  onChange={(val) =>
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'register_data_type',
                                      val,
                                    )
                                  }
                                  disabled={!isTenantAdmin}
                                />
                              </Td>
                            )}
                            {showAllColumns && (
                              <Td
                                ps={0}
                                borderColor="transparent"
                                textAlign="center"
                              >
                                <Default
                                  size="sm"
                                  type="number"
                                  value={param.offset}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'offset',
                                      val === '' ? '' : Number(val),
                                    );
                                  }}
                                  bg={inputBg}
                                  color={textColor}
                                  isDisabled={!isTenantAdmin}
                                />
                              </Td>
                            )}
                            {showAllColumns && (
                              <Td
                                ps={0}
                                borderColor="transparent"
                                textAlign="center"
                              >
                                <InterfaceSelect
                                  value={param.write_fn_code}
                                  options={writeFunctionCodes}
                                  onChange={(val) =>
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'write_fn_code',
                                      val,
                                    )
                                  }
                                  disabled={!isTenantAdmin}
                                />
                              </Td>
                            )}
                            <Td
                              ps={0}
                              borderColor="transparent"
                              textAlign="center"
                            >
                              <InterfaceSelect
                                value={param.access || 0}
                                options={Actions}
                                onChange={(val) => {
                                  const actionLabel = Object.keys(Actions).find(
                                    (key) => Actions[key] === val,
                                  );
                                  console.log(
                                    `[InterfaceSelect] slave.id=${slave.id}, param.id=${param.id}, selected=${actionLabel}, value=${val}`,
                                  );
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'access',
                                    val,
                                  );
                                }}
                                disabled={!isTenantAdmin}
                              />
                            </Td>
                            <Td
                              ps={2}
                              pr={2}
                              borderColor="transparent"
                              textAlign="center"
                              minW="120px"
                            >
                              {param.thresholds &&
                              param.thresholds.length > 0 ? (
                                <Flex
                                  align="start"
                                  justify="space-between"
                                  gap={2}
                                >
                                  <Text fontSize="sm" align="start">
                                    <Text as="span" fontWeight="semibold">
                                      Min:
                                    </Text>{' '}
                                    {param.thresholds[0].min}
                                    <br />
                                    <Text as="span" fontWeight="semibold">
                                      Max:
                                    </Text>{' '}
                                    {param.thresholds[0].max}
                                  </Text>
                                  <IconButton
                                    aria-label="Edit Threshold"
                                    icon={
                                      <EditIcon boxSize={4} color="blue.400" />
                                    }
                                    size="xs"
                                    justifyContent="end"
                                    alignItems="center"
                                    variant="ghost"
                                    onClick={() => {
                                      setSelectedThresholdParam({
                                        slave,
                                        param,
                                      });
                                      setMaxThreshold(
                                        param.thresholds?.[0]?.max ?? '',
                                      );
                                      setMinThreshold(
                                        param.thresholds?.[0]?.min ?? '',
                                      );
                                      setThresholdModalOpen(true);
                                    }}
                                    isDisabled={!isTenantAdmin}
                                  />
                                </Flex>
                              ) : (
                                <Flex
                                  align="start"
                                  justify="space-between"
                                  gap={2}
                                >
                                  <Text fontSize="sm" align="start">
                                    <Text as="span" fontWeight="semibold">
                                      Min:
                                    </Text>{' '}
                                    {'-'}
                                    <br />
                                    <Text as="span" fontWeight="semibold">
                                      Max:
                                    </Text>{' '}
                                    {'-'}
                                  </Text>
                                  {isTenantAdmin && (
                                    <IconButton
                                      aria-label="Edit Threshold"
                                      icon={
                                        <EditIcon
                                          boxSize={4}
                                          color="blue.400"
                                        />
                                      }
                                      size="xs"
                                      justifyContent="end"
                                      alignItems="center"
                                      variant="ghost"
                                      onClick={() => {
                                        setSelectedThresholdParam({
                                          slave,
                                          param,
                                        });
                                        setMaxThreshold(
                                          param.thresholds?.[0]?.max ?? '',
                                        );
                                        setMinThreshold(
                                          param.thresholds?.[0]?.min ?? '',
                                        );
                                        setThresholdModalOpen(true);
                                      }}
                                    />
                                  )}
                                </Flex>
                              )}
                            </Td>
                            <Td
                              ps={0}
                              textAlign="center"
                              borderColor="transparent"
                            >
                              {isTenantAdmin && (
                                <IconButton
                                  icon={<DeleteIcon />}
                                  aria-label="Delete parameter"
                                  size="sm"
                                  colorScheme="red"
                                  onClick={() =>
                                    confirmDelete(
                                      'parameter',
                                      slave.id,
                                      param.id,
                                    )
                                  }
                                  isDisabled={!isTenantAdmin}
                                />
                              )}
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    <Flex justify="space-between" align="center" mt={2}>
                      <Button
                        size="md"
                        onClick={() =>
                          handleParamPageChange(
                            slave.id,
                            Math.max((paramPages[slave.id] || 0) - 1, 0),
                          )
                        }
                        isDisabled={(paramPages[slave.id] || 0) === 0}
                      >
                        <ChevronLeftIcon />
                      </Button>
                      <Center flex="1">
                        <Text fontSize="sm" mx={2}>
                          Page {(paramPages[slave.id] || 0) + 1} of{' '}
                          {getTotalPages(slave)}
                        </Text>
                      </Center>
                      <Button
                        size="md"
                        onClick={() =>
                          handleParamPageChange(
                            slave.id,
                            Math.min(
                              (paramPages[slave.id] || 0) + 1,
                              getTotalPages(slave) - 1,
                            ),
                          )
                        }
                        isDisabled={
                          (paramPages[slave.id] || 0) >=
                          getTotalPages(slave) - 1
                        }
                      >
                        <ChevronRightIcon />
                      </Button>
                    </Flex>
                  </Box>
                )}

                <AssetParamDialog
                  open={openAssetMastermodel}
                  onClose={closeAssetParameterModal}
                  updateSlaveParams={updateSlaveParams}
                />

                {isTenantAdmin && (
                  <Flex justify="center" mt={3} gap={2}>
                    <Button
                      size="sm"
                      colorScheme="green"
                      variant="outline"
                      border="2px"
                      cursor="pointer"
                      onClick={() => handleSave(slave)}
                      isDisabled={!isSlaveChanged(slave)}
                    >
                      Save
                    </Button>

                    {/* <Button
                      size="sm"
                      mx="2"
                      variant="outline"
                      border="2px"
                      colorScheme="orange"
                      cursor="pointer"
                      onClick={() => addParameter(slave.id)}
                    >
                      Add Parameter
                    </Button> */}

                    <Button
                      variant="outline"
                      border="2px"
                      colorScheme="orange"
                      size="sm"
                      cursor="pointer"
                      onClick={() => {
                        setCurrentSlaveId(slave.id);
                        setOpen(true);
                      }}
                    >
                      Add Asset
                    </Button>
                  </Flex>
                )}
              </Card>
            );
          })}

          <AssetParamDialog
            open={open}
            onClose={() => {
              setOpen(false);
              setCurrentSlaveId(null);
            }}
            updateSlaveParams={updateSlaveParams}
          />

          {isTenantAdmin && (
            <Flex justify="center" mt={6} width="100%">
              <Button
                size="sm"
                variant="outline"
                border="2px"
                colorScheme="orange"
                cursor="pointer"
                ml={200}
                onClick={addSlave}
              >
                Add Slave
              </Button>
            </Flex>
          )}

          <GlobalAlertDialog
            isOpen={isDeleteOpen}
            onClose={() => setIsDeleteOpen(false)}
            onConfirm={handleDeleteConfirmed}
            title={
              deleteTarget.type === 'slave'
                ? 'Delete Slave'
                : 'Delete Parameter'
            }
            body={
              <>
                Are you sure you want to delete this{' '}
                {deleteTarget.type === 'slave' ? 'slave' : 'parameter'}? This
                action cannot be undone.
              </>
            }
            confirmText="Delete"
            cancelText="Cancel"
            showCancel={true}
          />

          <GlobalAlertDialog
            isOpen={isErrorOpen}
            onClose={() => setIsErrorOpen(false)}
            onConfirm={() => setIsErrorOpen(false)}
            title="Validation Error"
            body={errorMessage}
            confirmText="OK"
            showCancel={false}
          />

          <ThresholdModal
            isOpen={thresholdModalOpen}
            onClose={() => setThresholdModalOpen(false)}
            selectedParam={selectedThresholdParam}
            maxThreshold={maxThreshold}
            minThreshold={minThreshold}
            setMaxThreshold={setMaxThreshold}
            setMinThreshold={setMinThreshold}
            onAdd={handleAddThreshold}
          />

          <GlobalAlertDialog
            isOpen={isInterfaceChangeDialogOpen}
            onClose={handleCancelInterfaceChange}
            onConfirm={handleConfirmInterfaceChange}
            title="Change Interface"
            body="Are you sure you want to change the interface for this slave?"
            confirmText="Yes"
            cancelText="No"
            showCancel={true}
          />

          <GlobalAlertDialog
            isOpen={isApplyConfirmOpen}
            onClose={() => setIsApplyConfirmOpen(false)}
            onConfirm={async () => {
              setIsApplyConfirmOpen(false);
              await handleApplyToDevices();
            }}
            title="Apply Patch to Devices"
            body="Are you sure you want to save and apply this config ? "
            confirmText="Yes, Apply"
            cancelText="Cancel"
            showCancel={true}
          />

          <ClusterModal
            isOpen={isOpenSaveConf}
            onClose={() => {
              onCloseSaveConf();
              setCurrentPage(-1);
            }}
            title={`Save Configurations`}
            mainInputLabel="Config Name"
            mainInputValue={configName}
            onMainInputChange={(e) => setConfigName(e.target.value)}
            searchType={searchType}
            onSearchTypeChange={setSearchType}
            serialNumber={serialNumber}
            onSerialNumberChange={(e) => setSerialNumber(e.target.value)}
            onSerialNumberSearch={async (e) => {
              if (e.key === 'Enter') {
                fetchAllDevices(e.target.value, true, 0);
              }
            }}
            clusterOptions={clusterOptions}
            selectedCluster={selectedCluster}
            onClusterChange={setSelectedCluster}
            stateOptions={stateOptions}
            selectedState={selectedState}
            onStateChange={setSelectedState}
            nocOptions={nocOptions}
            selectedNoc={selectedNoc}
            onNocChange={setSelectedNoc}
            plantOptions={plantOptions}
            selectedPlant={selectedPlant}
            onPlantChange={setSelectedPlant}
            devicesArray={devicesArray}
            selectedDevices={selectedDevices}
            onDeviceToggle={handleCheckboxChange}
            onSelectAllDevices={(e) => {
              if (e.target.checked) {
                setSelectAllFlag(true);
                setSelectedDevices(devicesArray.map((d) => d.id));
              } else {
                setSelectAllFlag(false);
                setSelectedDevices([]);
              }
            }}
            loadingDevices={loadingDevices}
            onLoadMore={() => setCurrentPage((prev) => prev + 1)}
            onSave={handleSaveConfigurations2}
            saveDisabled={!configName}
            inputBg={inputBg}
            textColor={textColor}
            footerError={!configName}
            footerErrorText="Config name is required."
            deviceId={deviceId}
            preselectedDevices={
              preselectedDeviceIds.length > 0
                ? preselectedDeviceIds
                : location.state?.devices?.map((d) => d.device_id || d.id) || []
            }
            showMainInputDisabled={true}
            disablePreselectedDevices={true}
            disableCurrentDevice={false}
          />
        </Box>
      )}
      <Flex
        as="footer"
        position="fixed"
        left={0}
        bottom="0"
        width="100%"
        bg={useColorModeValue('gray.100', 'navy.800')}
        color={useColorModeValue('gray.600', 'gray.200')}
        py={2}
        px={4}
        align="center"
        justify="space-between"
        zIndex={20} // higher than sidebar
        borderTop="1px solid"
        borderColor={useColorModeValue('gray.200', 'gray.700')}
        boxShadow="0 -2px 8px rgba(0,0,0,0.04)"
      >
        <Text fontSize="sm" fontWeight="medium">
          Version 1.0.0
        </Text>
        <Text fontSize="sm" fontWeight="medium">
          UGX Systems
        </Text>
      </Flex>
    </>
  );
}
